import {useDebugValue} from 'react';

function useGuestsSelectors(data) {
    const {
        latestValues: {
            adultsCount
        }
    } = data;

    /* istanbul ignore next */
    function isValid() {
        return !!adultsCount;
    }

    const result = {
        isValid
    };

    useDebugValue(result);

    return result;
}

export {useGuestsSelectors};
